import { useEffect, useRef, useState } from "react";
import { productCategories } from "@/mocks/products";
import { siteData, type Product } from "@/store/siteData";
import { ProductCard } from "@/pages/home/components/ProjectsPreview";
import ProductModal from "@/pages/home/components/ProductModal";

export default function ProductsGrid() {
  const [visible, setVisible] = useState(false);
  const [filter, setFilter] = useState<Product["category"] | "all">("all");
  const [selected, setSelected] = useState<Product | null>(null);
  const ref = useRef<HTMLDivElement>(null);
  const products = siteData.getProducts();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.03 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const filtered = filter === "all" ? products : products.filter((p) => p.category === filter);
  const countFor = (slug: string) => (slug === "all" ? products.length : products.filter((p) => p.category === slug).length);

  return (
    <section ref={ref} data-edit="products" className="bg-white pt-28 pb-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        {/* Başlık */}
        <div className="mb-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#3B82F6]">Ürün Kataloğu</p>
          <h1 className="mt-2 font-display text-3xl font-bold text-[#0F172A] sm:text-4xl">Ürünlerimiz</h1>
          <p className="mt-2 text-sm text-[#64748B]">HP DMO kataloğundan kurumsal teknoloji ürünleri. Ürüne tıklayıp teklif alın.</p>
        </div>

        {/* Filtreler */}
        <div className={`flex flex-wrap gap-2 mb-3 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          {productCategories.map((c) => (
            <button
              key={c.slug}
              onClick={() => setFilter(c.slug)}
              className={`whitespace-nowrap flex items-center gap-1.5 px-5 py-2 text-xs font-semibold tracking-widest uppercase border rounded-lg transition-all duration-200 cursor-pointer ${
                filter === c.slug ? "text-white" : "border-[#E2E8F0] text-[#64748B] hover:text-[#3B82F6] hover:border-[#3B82F6] bg-white"
              }`}
              style={filter === c.slug ? { background: c.color, borderColor: c.color } : {}}
            >
              <i className={c.icon}></i>{c.label} <span className="opacity-70">({countFor(c.slug)})</span>
            </button>
          ))}
        </div>
        <p className="text-[#94A3B8] text-xs mb-8">{filtered.length} ürün gösteriliyor · Kaynak: DMO kataloğu</p>

        {/* Ürün gridi */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {filtered.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} visible={visible} onClick={() => setSelected(p)} />
          ))}
        </div>
      </div>

      {selected && <ProductModal product={selected} onClose={() => setSelected(null)} />}
    </section>
  );
}
